export default __webpack_public_path__ + "static/media/weight.3e3d5cc9.svg";